
import {
  IconChevronRight,
  RevList,
  RevListItem,
  RevSkeleton,
} from '@backmarket/design-system'

import { STATUSES } from '../RecommendationBundle.constants'

import translations from './BundleSmallToModalButton.translations'

export default {
  components: { IconChevronRight, RevList, RevListItem, RevSkeleton },
  props: {
    totalPrice: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    isFetching() {
      return this.status === STATUSES.FETCHING
    },
  },
}
